<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../../_common/z/ztab.svelte'
    import UserPersonalizeNotifications from './user-personalize-notifications.svelte'

    let tabs = [
        {
            title: 'Notificações',
            url: '/personalize/notifications',
        },
    ]
</script>

<div class="limit-1900 p-2 m-bottom-sm">
    <Ztab {tabs} />
    <Router>
        <Route path="/notifications">
            <UserPersonalizeNotifications />
        </Route>
    </Router>
</div>

<style>
</style>
